import { useMutation } from "@tanstack/react-query";
import { unitsFieldsAdd } from "common/api/citajteo/dl_unit/dl_unit_edit";
import { UnitsFieldsSourceType } from "constant/dl_unit/dl_unit_field.constant";
import { useInvalidateQueryByKeys } from "hooks/query_common/useInvalidateQueryByKeys";
import { UnitFields } from "type/dl_unit/dl_unit.type";

type UseUnitsFieldsAddParams = {
  invalidateKeys?: string[];
  successHandle?: Function;
  errorHandle?: Function;
};

export const useUnitsFieldsAdd = (hookParams?: UseUnitsFieldsAddParams) => {
  const { invalidateQueriesByKeys } = useInvalidateQueryByKeys();
  const { mutate: unitsFieldsAddMutate } = useMutation({
    mutationFn: async (params: {
      sourceType: UnitsFieldsSourceType | "";
      fields: UnitFields[];
    }) => {
      const response = await unitsFieldsAdd(params.sourceType, params.fields);

      if (response === "") {
        throw new Error("unitsFieldsAdd failed");
      }

      return response;
    },
    onSuccess: (response) => {
      if (hookParams?.invalidateKeys) {
        invalidateQueriesByKeys(hookParams.invalidateKeys);
      }

      if (hookParams?.successHandle) {
        hookParams.successHandle(response);
      }
    },
    onError: (error) => {
      if (hookParams?.errorHandle) {
        hookParams.errorHandle(error);
      }
    },
  });

  return { unitsFieldsAddMutate };
};
